<template>
   <Breadcrumbs main="Card" title="Card performance" />
   
   <!-- Loading Overlay -->
   <LoadingOverlay :show="isLoading" message="Loading..." />
   
   <div class="card-performance-container">
   <div class="card-performance-header">
      <div class="header-right">
        <!-- Status filter -->
        <div class="dropdown-wrapper">
            <button @click="toggleStateDropdown" class="btn-all"
            >State <span v-if="activeState">:{{ activeState }}</span>
                <i class="fa fa-caret-down"></i>
            </button>
                <div v-if="showStateDropdown" class="dropdown-content">
                    <button
                      class="state-option"
                      @click="setActiveState('')"
                      :class="{ active: activeState === '' }"
                    >
                      All
                    </button>
                    <button
                      v-for="state in states"
                      :key="state"
                      class="state-option"
                      :class="{ active: activeState === state }"
                      @click="setActiveState(state)"
                    >
                      {{ state }}
                    </button>
            <div class="dropdown-footer">
                <button class="btn-cancel" @click="cancelStateFilter">Cancel</button>
                <button class="btn-ok" @click="confirmStateFilter">OK</button>
            </div>
                </div>
        </div>
        
        <!-- Payment method filter -->
        <div class="dropdown-wrapper">
            <button @click="togglePaymentMethodDropdown" class="btn-all"
            >Payment method <span v-if="activePaymentMethod">:{{ activePaymentMethod }}</span>
                <i class="fa fa-caret-down"></i>
            </button>
                <div v-if="showPaymentMethodDropdown" class="dropdown-content">
                    <button
                      class="state-option"
                      @click="setActivePaymentMethod('')"
                      :class="{ active: activePaymentMethod === '' }"
                    >
                      All
                    </button>
                    <button
                      v-for="method in paymentMethods"
                      :key="method"
                      class="state-option"
                      :class="{ active: activePaymentMethod === method }"
                      @click="setActivePaymentMethod(method)"
                    >
                      {{ method }}
                    </button>
            <div class="dropdown-footer">
                <button class="btn-cancel" @click="cancelPaymentMethodFilter">Cancel</button>
                <button class="btn-ok" @click="confirmPaymentMethodFilter">OK</button>
            </div>
                </div>
        </div>
        
        <!-- Unused terminal filter -->
        <div class="dropdown-wrapper">
            <button class="btn-all" 
            @click="toggleUnusedTerminalDropdown"
            >Unused terminal <i class="fa fa-caret-down"/>
            <span v-if="activeUnusedTerminal">:{{ activeUnusedTerminal }}</span>
         </button>
         <div v-if="showUnusedTerminalDropdown" class="dropdown-content">
            <button
                      class="state-option"
                      @click="setUnusedTerminal('')"
                      :class="{ active: activeUnusedTerminal === '' }"
                    >
                      All
                    </button>
                    <button
                      v-for="terminal in unusedTerminals"
                      :key="terminal"
                      class="state-option"
                      :class="{ active: activeUnusedTerminal === terminal }"
                      @click="setUnusedTerminal(terminal)"
                    >
                      {{ terminal }}
                    </button>
                    <div class="dropdown-footer">
                <button class="btn-cancel" @click="cancelUnusedTerminalFilter">Cancel</button>
                <button class="btn-ok" @click="confirmUnusedTerminalFilter">OK</button>
            </div>
        </div>
        </div>
        
        <!-- Unused cards filter -->
        <div class="dropdown-wrapper">
            <button class="btn-all" 
            @click="toggleUnusedCardsDropdown"
            >Unused cards <i class="fa fa-caret-down"/>
            <span v-if="activeUnusedCards">:{{ activeUnusedCards }}</span>
         </button>
         <div v-if="showUnusedCardsDropdown" class="dropdown-content">
            <button
                      class="state-option"
                      @click="setUnusedCards('')"
                      :class="{ active: activeUnusedCards === '' }"
                    >
                      All
                    </button>
                    <button
                      v-for="card in unusedCards"
                      :key="card"
                      class="state-option"
                      :class="{ active: activeUnusedCards === card }"
                      @click="setUnusedCards(card)"
                    >
                      {{ card }}
                    </button>
                    <div class="dropdown-footer">
                <button class="btn-cancel" @click="cancelUnusedCardsFilter">Cancel</button>
                <button class="btn-ok" @click="confirmUnusedCardsFilter">OK</button>
            </div>
        </div>
        </div>
      </div>
       <div class="header-left">
        <div class="search-box">

        
        <button @click="clearAllFilters">clear all filters</button>
       <div>
        <input 
          type="text" 
          class="form-control" 
          placeholder="Search..."
          v-model="searchQuery"
          @input="onSearchInput"
        >
        <Icon
          :icon="searchIcon"
          width="30"
          height="30"
          class="search-icon"
          @click="onSearchIconClick"
        />
       </div>
    </div>
       </div>
   </div>
   <div class="mt-3">
    <div class="table-performance-wrapper">
    <table class="table-performance">
        <thead>
            <tr>
                <th v-for="header in cardPerformance" 
                :key="header.value" 
                :class="{'header-active' :activeHeader === header.value}" 
                @click="setActiveHeader(header.value)">
                    <div class="d-flex justify-content-between align-items-center">
                        {{ header.label }} 
                    <div>
                        <i v-if="activeHeader === header.value && sortOrder === 'asc'" class="fa fa-sort-asc"></i>
                        <i v-else-if="activeHeader === header.value && sortOrder === 'desc'" class="fa fa-sort-desc"></i>
                        <i v-else class="fa fa-sort muted"></i>
                    </div>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-if="!cardStore.cardPerformanceList || cardStore.cardPerformanceList.length === 0">
                <td :colspan="cardPerformance.length" style="text-align: center; padding: 40px; color: #999;">
                    No data found
                </td>
            </tr>
            <tr v-for="(card, index) in sortedCardList" :key="index">
                <td>{{ card.status || '-' }}</td>
                <td>{{ card.EAID || '-' }}</td>
                <td>{{ card.driver_id || '-' }}</td>
                <td>{{ card.fleet_id || '-' }}</td>
                <td>{{ card.driver_name || '-' }}</td>
                <td>{{ card.payment_method || '-' }}</td>
                <td>{{ formatCurrency(card.card_balance) }}</td>
                <td>{{ card.last_terminal_transaction_datetime || '-' }}</td>
                <td>{{ formatInactiveTime(card.terminal_inactive_time) }}</td>
                <td>{{ card.last_card_transaction_datetime || '-' }}</td>
                <td>{{ formatInactiveTime(card.card_inactive_time) }}</td>
            </tr>
        </tbody>
    </table>
    </div>
    <div class="pagination-container" v-if="cardStore.cardPerformanceMeta">
        <div class="pagination-wrapper">
            <div>
                <button @click="changePage(1)" style="cursor: pointer;">
                    <img src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" />
                </button>
                <button @click="changePage(Math.max(1, paginationInfo.current - 1))" style="cursor: pointer;">
                    <img src="@/assets/images/admin/arrow/prev.png" alt="Prev" style="width: 25px; height: 25px;" />
                </button>
                <span>Page
                    <input type="number" v-model.number="currentPageInput" @change="changePage(currentPageInput)" min="1" :max="paginationInfo.total" style="width: 60px;">
                    of {{ paginationInfo.total }}
                </span>
                <button @click="changePage(Math.min(paginationInfo.total, paginationInfo.current + 1))" style="cursor: pointer;">
                    <img src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" />
                </button>
                <button @click="changePage(paginationInfo.total)" style="cursor: pointer;">
                    <img src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" />
                </button>
            </div>
            <div>
                Displaying {{ paginationInfo.start }} - {{ paginationInfo.end }} of {{ paginationInfo.totalItems }}
            </div>
        </div>
    </div>
   </div>
   </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { Icon } from '@iconify/vue';
import { useCardStore } from '@/store/admin/card';
import { useTerminalPerformanceStore } from '@/store/admin/terminalPerformance';
import { formatAmount } from '@/utils/formatters';
import LoadingOverlay from '@/components/LoadingOverlay.vue';


const cardStore = useCardStore();
const terminalStore = useTerminalPerformanceStore();
const isLoading = ref(false); // Loading 狀態

const activeState = ref('');
const showStateDropdown = ref(false);
const showUnusedTerminalDropdown = ref(false);
const activeUnusedTerminal = ref('');
const showPaymentMethodDropdown = ref(false);
const activePaymentMethod = ref('');
const showUnusedCardsDropdown = ref(false);
const activeUnusedCards = ref('');
const currentPageInput = ref(1);
const searchQuery = ref('');

const searchIcon = computed(() =>
  searchQuery.value ? 'mdi:close' : 'mdi:magnify'
)
const cardPerformance = [
    {label: 'State', value: 'state'},
    {label: 'EAID', value: 'eaid'},
    {label: 'Driver ID', value: 'driver_id'},
    {label: 'Fleet ID', value: 'fleet_id'},
    {label: 'Driver name', value: 'driver_name'},
    {label: 'Payment method', value: 'payment_method'},
    {label: 'Card balance', value: 'card_balance'},
    {label: 'Last terminal transaction date/time', value: 'last_terminal_transaction_date_time'},
    {label: 'Terminal inactive time', value: 'terminal_inactive_time'},
    {label: 'Last card transaction date/time', value: 'last_card_transaction_date_time'},
    {label: 'Card inactive time', value: 'card_inactive_time'},
]


const states = ['NSW', 'VIC', 'QLD', 'SA', 'WA', 'NT', 'TAS', 'ACT'];
const paymentMethods = ['Cash', 'Card', 'Bank transfer'];
const unusedTerminals = ['1 month', '2 months', '3 months', '4 months', '5 months', '6 months'];
const unusedCards = ['1 month', '2 months', '3 months', '4 months', '5 months', '6 months'];

const toggleStateDropdown = () => {
    showStateDropdown.value = !showStateDropdown.value;
}

const togglePaymentMethodDropdown = () => {
    showPaymentMethodDropdown.value = !showPaymentMethodDropdown.value;
}

const toggleUnusedTerminalDropdown = () => {
    showUnusedTerminalDropdown.value = !showUnusedTerminalDropdown.value;
}

const toggleUnusedCardsDropdown = () => {
    showUnusedCardsDropdown.value = !showUnusedCardsDropdown.value;
}

const setActiveState = (state) => {
    activeState.value = state;
}

const setActivePaymentMethod = (method) => {
    activePaymentMethod.value = method;
}

const setUnusedTerminal = (terminal) => {
    activeUnusedTerminal.value = terminal;
}

const setUnusedCards = (card) => {
    activeUnusedCards.value = card;
}

const cancelStateFilter = () => {
    showStateDropdown.value = false;
}

const cancelPaymentMethodFilter = () => {
    showPaymentMethodDropdown.value = false;
}

const cancelUnusedCardsFilter = () => {
    showUnusedCardsDropdown.value = false;
}

const confirmStateFilter = () => {
    showStateDropdown.value = false;
    loadCardPerformanceList(1);
}

const confirmPaymentMethodFilter = () => {
    showPaymentMethodDropdown.value = false;
    loadCardPerformanceList(1);
}

const confirmUnusedCardsFilter = () => {
    showUnusedCardsDropdown.value = false;
    loadCardPerformanceList(1);
}

const activeHeader = ref(cardPerformance[0].value);
const sortOrder = ref('desc');

// 計算分頁資訊
const paginationInfo = computed(() => {
    const meta = cardStore.cardPerformanceMeta;
    if (!meta) return { current: 1, total: 1, totalItems: 0, start: 0, end: 0 };
    
    const current = meta.current_page || 1;
    const total = meta.last_page || 1;
    const totalItems = meta.total || 0;
    const pageSize = meta.per_page || 10;
    const start = totalItems > 0 ? (current - 1) * pageSize + 1 : 0;
    const end = Math.min(current * pageSize, totalItems);
    
    return { current, total, totalItems, start, end };
});

// 排序後的卡片列表
const sortedCardList = computed(() => {
    if (!cardStore.cardPerformanceList || cardStore.cardPerformanceList.length === 0) {
        return [];
    }
    
    const list = [...cardStore.cardPerformanceList];
    const order = sortOrder.value === 'asc' ? 1 : -1;
    
    list.sort((a, b) => {
        let aValue, bValue;
        
        switch (activeHeader.value) {
            case 'state':
                aValue = (a.status || '').toLowerCase();
                bValue = (b.status || '').toLowerCase();
                break;
            case 'eaid':
                aValue = (a.EAID || '').toLowerCase();
                bValue = (b.EAID || '').toLowerCase();
                break;
            case 'driver_id':
                aValue = (a.driver_id || '').toLowerCase();
                bValue = (b.driver_id || '').toLowerCase();
                break;
            case 'fleet_id':
                aValue = (a.fleet_id || '').toLowerCase();
                bValue = (b.fleet_id || '').toLowerCase();
                break;
            case 'driver_name':
                aValue = (a.driver_name || '').toLowerCase();
                bValue = (b.driver_name || '').toLowerCase();
                break;
            case 'payment_method':
                aValue = (a.payment_method || '').toLowerCase();
                bValue = (b.payment_method || '').toLowerCase();
                break;
            case 'card_balance':
                aValue = parseFloat(a.card_balance) || 0;
                bValue = parseFloat(b.card_balance) || 0;
                break;
            case 'last_terminal_transaction_date_time':
                aValue = a.last_terminal_transaction_datetime || '';
                bValue = b.last_terminal_transaction_datetime || '';
                break;
            case 'terminal_inactive_time':
                aValue = parseFloat(a.terminal_inactive_time) || 0;
                bValue = parseFloat(b.terminal_inactive_time) || 0;
                break;
            case 'last_card_transaction_date_time':
                aValue = a.last_card_transaction_datetime || '';
                bValue = b.last_card_transaction_datetime || '';
                break;
            case 'card_inactive_time':
                aValue = parseFloat(a.card_inactive_time) || 0;
                bValue = parseFloat(b.card_inactive_time) || 0;
                break;
            default:
                return 0;
        }
        
        if (aValue < bValue) return -1 * order;
        if (aValue > bValue) return 1 * order;
        return 0;
    });
    
    return list;
});

const setActiveHeader = (header) => {
    if (activeHeader.value === header) {
        sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
    } else {
        activeHeader.value = header;
        sortOrder.value = 'desc';
    }
}

// 格式化貨幣
const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return '-';
    return formatAmount(amount);
};

// 格式化非活躍時間
const formatInactiveTime = (time) => {
    if (time === null || time === undefined) return '-';
    if (typeof time === 'number') {
        return `${time} days`;
    }
    return time;
};

// 將 "1 week", "2 weeks" 或 "1 month", "2 months" 等轉換為數字
const convertPeriodToNumber = (periodStr) => {
    if (!periodStr) return null;
    // 匹配 "1 week", "2 weeks", "1 month", "2 months" 等格式
    const match = periodStr.match(/(\d+)\s*(week|month)/i);
    return match ? parseInt(match[1]) : null;
};

// 載入資料
const loadCardPerformanceList = async (page = 1) => {
    try {
        isLoading.value = true; // 開始 loading
        const params = {
            page: page,
            per_page: 10,
        };
        
        // 只添加有選擇的篩選參數
        if (activeState.value) {
            params.status = activeState.value;
        }
        if (activePaymentMethod.value) {
            params.payment_method = activePaymentMethod.value;
        }
        if (activeUnusedTerminal.value) {
            // 將 "1 month" 轉換為數字 1
            const terminalNum = convertPeriodToNumber(activeUnusedTerminal.value);
            if (terminalNum !== null) {
                params.unused_terminal = terminalNum;
            }
        }
        if (activeUnusedCards.value) {
            // 將 "1 month" 轉換為數字 1
            const cardsNum = convertPeriodToNumber(activeUnusedCards.value);
            if (cardsNum !== null) {
                params.unused_cards = cardsNum;
            }
        }
        if (searchQuery.value && searchQuery.value.trim()) {
            params.search = searchQuery.value.trim();
        }
        
        console.log('Loading card performance with params:', params);
        await cardStore.fetchCardPerformanceList(params);
        
        // 同步更新分頁輸入框
        if (cardStore.cardPerformanceMeta?.current_page) {
            currentPageInput.value = cardStore.cardPerformanceMeta.current_page;
        }
    } catch (error) {
        console.error('Failed to load card performance list:', error);
    } finally {
        isLoading.value = false; // 結束 loading
    }
};

// 分頁處理
const changePage = (page) => {
    if (page >= 1 && page <= paginationInfo.value.total) {
        currentPageInput.value = page;
        loadCardPerformanceList(page);
    }
};

// 監聽分頁資訊變化
watch(() => paginationInfo.value.current, (newCurrent) => {
    if (newCurrent && newCurrent !== currentPageInput.value) {
        currentPageInput.value = newCurrent;
    }
});

// 搜尋功能
let searchTimeout = null;
const onSearchInput = () => {
    console.log('Search input triggered, value:', searchQuery.value);
    // 使用 debounce 避免過於頻繁的請求
    if (searchTimeout) {
        clearTimeout(searchTimeout);
    }
    searchTimeout = setTimeout(() => {
        currentPageInput.value = 1;
        loadCardPerformanceList(1);
    }, 500); // 等待 500ms 後才執行搜尋
};

const onSearchIconClick = () => {
    console.log('Search icon clicked');
    if (searchQuery.value) {
        searchQuery.value = '';
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }
        currentPageInput.value = 1;
        loadCardPerformanceList(1);
    }
};

// 初次載入
onMounted(() => {
    // 檢查 store 中是否有預設的 inactivePeriod（從 Dashboard 跳轉過來）
    const storedPeriod = terminalStore.filters.inactivePeriod;
    const filterType = terminalStore.filters.filterType; // 獲取篩選類型
    
    if (storedPeriod && storedPeriod !== 'ALL') {
        // 將 store 的值映射到對應格式
        // 例如: '1_month' -> '1 month'
        const periodMap = {
            '1_month': '1 month',
            '2_month': '2 months',
            '3_month': '3 months',
            '4_month': '4 months',
            '5_month': '5 months',
            '6_month': '6 months',
        };
        
        const mappedPeriod = periodMap[storedPeriod];
        if (mappedPeriod) {
            // 根據類型設置到對應的篩選變數
            if (filterType === 'terminal') {
                activeUnusedTerminal.value = mappedPeriod;
            } else if (filterType === 'card') {
                activeUnusedCards.value = mappedPeriod;
            }
        }
        
        // 清除 store 的值（使用一次後清除，避免下次進入頁面時還會套用）
        terminalStore.filters.inactivePeriod = 'ALL';
        terminalStore.filters.filterType = '';
    }
    
    loadCardPerformanceList(1);
});

const cancelUnusedTerminalFilter = () => {
    showUnusedTerminalDropdown.value = false;
}

const confirmUnusedTerminalFilter = () => {
    showUnusedTerminalDropdown.value = false;
    loadCardPerformanceList(1);
}

// 清除所有 filters
const clearAllFilters = () => {
    activeState.value = '';
    activePaymentMethod.value = '';
    activeUnusedTerminal.value = '';
    activeUnusedCards.value = '';
    searchQuery.value = '';
    showStateDropdown.value = false;
    showPaymentMethodDropdown.value = false;
    showUnusedTerminalDropdown.value = false;
    showUnusedCardsDropdown.value = false;
    currentPageInput.value = 1;
    loadCardPerformanceList(1);
}
</script>

<style scoped>
.card-performance-container{
    background-color:white;
    padding:20px;
    border-radius:5px;
    min-height:750px;
    height:auto;
}
.card-performance-header{
    display:flex;
    
}
.header-right{
   display:flex;
   width: 80%;
   flex-wrap:wrap;
}
.header-left{
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    width: 20%;
}
.search-box {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    width: 100%;
}
.search-box button {
    background-color:white;
    border:none;
    color:#5248DA;
    font-size:18px;
}
.search-box > div {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
}

.btn-all{
    background-color:white;
    border:1px solid #5248DA;
    border-radius:30px;
    color:#5248DA;
    padding:10px 20px;
    font-size:16px;
    cursor:pointer;
    margin:3px 5px;
}
.month-button{
    min-width: 140px;
}
.search-box .search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color:black;
  cursor: pointer;
  z-index: 1;
}
.table-performance{
    width: 100%;
    table-layout: auto;
    min-width: 1200px;
}
.table-performance thead th{
    border-right:1px solid #e4e7ec;
    padding:12px 15px;
    white-space: nowrap;
    font-size: 14px;
}
.table-performance thead th:last-child{
    border:none;
}
.table-performance tbody td{
    padding:12px 15px;
    border-bottom:1px solid #e4e7ec;
    white-space: nowrap;
}

.table-performance tbody tr:hover {
    background-color: #f8f9fa;
}

.table-performance thead th.header-active{
    color:#00C962;
    border-bottom:2px solid #00C962;
}
.pagination-wrapper{
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:10px;
    padding-top:15px;
    margin-top: 10px;
}
.pagination-wrapper button{
    border:none;
    background-color:white;
}
.pagination-wrapper input{
    width:50px;
}
.dropdown-content{
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 2000;
  padding: 10px;
  width: 200px;
  border-radius: 10px;
}
.dropdown-wrapper{
  position: relative;
  display: inline-flex;
}
.custom-date-dropdown{
  width: 260px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.custom-date-dropdown .btn-ok:disabled{
  opacity: 0.5;
  cursor: not-allowed;
}
.state-option{
    width: 100%;
    padding: 10px;
    text-align: left;
    background: none;
    border: none;
    cursor: pointer;
    display: block;
}
.state-option.active {
  background-color: #8476f4;
  color: white;
}
.dropdown-footer button{
    border:none;
    font-size:16px;
    color:#8476f4;
    background-color:white;
    cursor:pointer;
    
}
.btn-all.active{
    background-color:#8476f4;
    color:white;
}
.table-performance-wrapper{
    width: 100%;
    overflow-x: auto;
    margin-top: 15px;
    padding-bottom: 10px;
}

@media (max-width: 992px) {
  .card-performance-header{
      flex-direction: column;
      gap: 20px;
  }
  .header-right,
  .header-left{
      width: 100%;
  }
  .month-button{
      flex: 0 0 calc(50% - 10px);
      max-width: calc(50% - 10px);
  }
  .header-left{
      justify-content: flex-start;
  }
  .search-box{
      align-items: flex-start;
  }
  .search-box button{
      font-size: 16px;
  }
  .btn-all{
      font-size: 14px;
      padding: 8px 16px;
  }
  .dropdown-wrapper{
      width: 100%;
      flex-wrap: wrap;
  }
  .dropdown-content{
      width: clamp(220px, 80vw, 360px);
  }
  .table-performance{
      table-layout: auto;
      min-width: 1400px;
  }
  .pagination-container{
      flex-direction: column;
      gap: 12px;
      align-items: flex-start;
  }
}

@media (max-width: 576px) {
  .btn-all{
      width: 100%;
      justify-content: center;
  }
  .month-button{
      width: calc(50% - 8px);
      display: inline-flex;
  }
  .dropdown-wrapper{
      display: block;
  }
  .dropdown-content{
      width: 100%;
      left: 0;
  }
  .card-performance-container{
      padding: 16px;
  }
  .table-performance{
      min-width: 1200px;
  }
  .pagination-wrapper{
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
  }
  .pagination-wrapper button{
      padding: 4px;
  }
  .pagination-wrapper span{
      font-size: 14px;
  }
  .search-box button{
      align-self: stretch;
      text-align: left;
  }
  .dropdown-wrapper .dropdown-content{
      position: static;
      width: 100%;
      margin-top: 8px;
      box-shadow: none;
      border: 1px solid #e4e7ec;
  }
}

</style>